"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Grid = _interopRequireDefault(require("./Grid"));

exports.default = _Grid.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/collections/Grid/index.js
// module id = 1455
// module chunks = 0